import PropTypes from 'prop-types';
import * as React from 'react';
import { EXPERIMENTS } from '../../constants/experiments.js';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { useExperimentsContext } from '../../contexts/experiments/experiments.context.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { RenderComp } from '../core/render-comp.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpreadProps(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
const propTypes = {
  skin: PropTypes.oneOf(['unstyled', 'link', 'primary', 'secondary', 'clear-selection', 'accent']),
  sizeVariant: deprecatedProp(PropTypes.oneOf(['standard', 'mini']), DEPRECATED_PROP_MESSAGES.size),
  size: PropTypes.oneOf(['standard', 'mini']),
  widthVariant: deprecatedProp(PropTypes.oneOf(['standard', 'full-width', 'wide']), DEPRECATED_PROP_MESSAGES.width),
  width: PropTypes.oneOf(['standard', 'full-width', 'wide']),
  specialVariant: PropTypes.oneOf(['standard', 'design-path']),
  iconPosition: PropTypes.oneOf(['right', 'left']),
  buttonShape: PropTypes.oneOf(['standard', 'round'])
};
const propKeysToRemove = Object.keys(propTypes);
const Button = renderWithRef('Button', propTypes, (props, ref) => {
  const swanExperiments = useExperimentsContext(props.experiment);
  const buttonSkinsWithoutBaseClass = ['unstyled', 'clear-selection', 'link'];
  const {
    as,
    component,
    skin = 'secondary',
    sizeVariant = 'standard',
    size = sizeVariant,
    widthVariant = 'standard',
    width = widthVariant,
    specialVariant,
    iconPosition,
    buttonShape,
    children,
    type
  } = props;
  const Comp = as || component || 'button';
  const buttonType = Comp === 'button' || Comp === 'input' ? type || 'button' : type;
  const applyBaseClass = !buttonSkinsWithoutBaseClass.includes(skin || 'secondary');
  const classNames = new Set([]);
  if (swanExperiments.has(EXPERIMENTS.buttonCTA)) {
    classNames.add('swan-exp-cta-evaluation');
  }
  if (applyBaseClass) {
    classNames.add('swan-button');
    classNames.add("swan-button-skin-".concat(skin));
  }
  if (!applyBaseClass) classNames.add("swan-button-skin-".concat(skin));
  if (buttonShape === 'round') classNames.add('swan-button-round');
  if (iconPosition === 'left') classNames.add('swan-button-with-icon-left');
  if (specialVariant === 'design-path' && !iconPosition || iconPosition === 'right') classNames.add('swan-button-with-icon-right');
  if (size !== 'standard' && applyBaseClass) classNames.add("swan-button-".concat(size));
  if (size !== 'standard' && !applyBaseClass) classNames.add("swan-button-".concat(size));
  if (width !== 'standard') classNames.add("swan-button-".concat(width));
  if (specialVariant === 'design-path') classNames.add("swan-button-design-path");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RenderComp, {
    root: "button",
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: classNames,
    props: Comp === 'button' || Comp === 'input' ? _objectSpreadProps(_objectSpread({}, props), {
      type: buttonType
    }) : props
  }, children));
});
Button.defaultProps = {
  skin: 'secondary',
  buttonShape: 'standard'
};
export { Button };